import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../../store/index";
import { logout, selectCurrentUser } from "../../store/slices/authSlice";
import { updateUserName } from "../../store/modules/userData";
import { apiSlice } from "../../features/api/apiSlice";
import { useLogoutMutation } from "../../features/auth/authApiSlice";

const Logoutmodal = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const reduxUserData = useSelector((state) => state?.user?.name);
  const [logoutApi] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      // 0. Notify backend that client user is logging out to update online status & telemetry
      const token = localStorage.getItem("token") || localStorage.getItem("accessToken");
      const userId =
        currentUser?._id ||
        currentUser?.id ||
        reduxUserData?._id ||
        reduxUserData?.id ||
        localStorage.getItem("userid") ||
        localStorage.getItem("id");

      await logoutApi({ userId, token }).unwrap();
    } catch (err) {
      console.warn("[Logout] Backend session logout notice:", err);
    } finally {
      // 1. Dispatch logout — clears auth state & localStorage token
      dispatch(logout());

      // 2. Clear legacy user profile data slice
      dispatch(updateUserName(""));

      // 3. Reset RTK Query cache
      dispatch(apiSlice.util.resetApiState());

      // 4. Clear marketer-related localStorage keys
      localStorage.removeItem("MeAsmarketerId");
      localStorage.removeItem("MeAsmarketerUserId");
      localStorage.removeItem("MarketerFor");

      // 5. Purge redux-persist storage
      persistor.purge().then(() => {
        // 6. Navigate to login page
        navigate("/login");
      });
    }
  };

  return (
    <>
      <Modal
        show={show}
        animation={true}
        onHide={handleClose}
        className="mt-5 pt-5"
      >
        <Modal.Body className="col-8 mx-auto text-center p-t-3 pb-3">
          <h5 className="mt-4">
            Are You Sure You Want to
            <span style={{ color: "#3D3BEE" }}> Logout</span>
          </h5>
        </Modal.Body>
        <div className="d-flex justify-content-center pb-4">
          <button className="post-btn" onClick={handleClose}>
            Cancel
          </button>
          <button className="ms-3 cancle-btn" onClick={handleLogout}>
            Yes
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Logoutmodal;
